/* Built In Imports */
import React from 'react';

/* External Imports */
import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
    Image,
    ListItem,
    Text,
    UnorderedList,
} from '@chakra-ui/react';
import { subDays } from 'date-fns';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import BtnTryForFree from '@landing_pages/SadhguruExclusive/BtnTryForFree';
import SgXSectionTitle from '@landing_pages/SadhguruExclusive/SgXSectionTitle';
/* Services */
// import { fetchPackageData } from 'services/exclusiveService';

/* Styles */

/**
 * Renders the SubscriptionPlanPromo component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} SubscriptionPlan component
 */

const SubscriptionPlanPromo = ({
  sectionContent,
  region,
  language,
  sectionId,
  eventtype,
  PackageData,
}) => {
  // const [PackageData, setPackageData] = useState([]);
  let setSectionId = '';
  if (sectionId != undefined) {
    setSectionId = sectionId;
  } else {
    setSectionId = 'Subscription';
  }
  const subscripData = sectionContent.body.find(
    el => el.sectionId == setSectionId
  );
  // console.log('data', subscripData);
  const posturl = refineUrlDomain(
    subscripData?.sectionContent[7]?.linkUrl,
    region,
    language
  );
  // useEffect(async () => {
  //   localData();
  // }, [region]);
  // const localData = async () => {
  //   const res = await fetchPackageData(region, language);
  //   const PackageData = res.data;
  //   // console.log('package', PackageData);
  //   setPackageData(PackageData);
  // };
  /**
   *
   * @param newDate
   */
  function formatDate(newDate) {
    const months = {
      0: 'Jan',
      1: 'Feb',
      2: 'Mar',
      3: 'Apr',
      4: 'May',
      5: 'Jun',
      6: 'Jul',
      7: 'Aug',
      8: 'Sep',
      9: 'Oct',
      10: 'Nov',
      11: 'Dec',
    };
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const d = newDate;
    const year = d.getFullYear();
    const date = d.getDate();
    const monthIndex = d.getMonth();
    const monthName = months[d.getMonth()];
    const dayName = days[d.getDay()]; // Thu
    const formatted = `${date} ${monthName} ${year}`;
    return formatted.toString();
  }

  /**
   *
   */
  function onsubmit() {
    document.querySelector('#package_name').value = document.querySelector(
      'input[name="planfee"]:checked'
    ).value;
    document.querySelector('#iso2').value = region.toUpperCase();
    subscribe.submit();
  }
  /**
   *
   * @param packagename
   * @param ios2
   */
  function formsubmit(packagename, ios2) {
    document.querySelector('#package_name').value = packagename;
    document.querySelector('#iso2').value = ios2;
    subscribe.submit();
  }

  return (
    <>
      <a name="subscriptionplan" />
      <form
        id="subscribeplan"
        method="post"
        name="subscribe"
        action={posturl}
        enctype="application/json"
      >
        <input type="hidden" name="package" id="package_name" />
        <input type="hidden" name="country" id="iso2" />
        <input type="hidden" name="offer" id="offer_code" value="ANNUAL14DAY" />

        <Box marginTop="100px" padding="20px 0">
          <SgXSectionTitle sectionContent={subscripData?.sectionContent[0]} />
        </Box>
        <Box
          background="#2f2c29"
          marginTop="30px"
          borderRadius="12px"
          padding={{ base: '40px 25px', lg: '40px 50px' }}
          width={{ base: '92%', sm: '92%', lg: '882px' }}
          margin="30px auto 0"
          color="#A8967F"
        >
          <Box marginBottom="20px">
            <Text
              as="p"
              fontFamily="FedraSansStd-book"
              fontSize={{ base: '18px', lg: '22px' }}
              color="#ffffff"
            >
              {subscripData?.sectionContent[1]?.titleSubtext}
            </Text>
            <Text
              as="p"
              fontWeight="bold"
              fontSize={{ base: '20px', lg: '24px' }}
              color="#FFBD31"
            >
              {subscripData?.sectionContent[1]?.titleText}
            </Text>
          </Box>
          {subscripData?.sectionContent[2].text != '' && (
            <>
              <UnorderedList
                display="inline-block"
                textAlign={{ base: 'left', md: 'center' }}
                fontSize={{ base: '16px', lg: '20px' }}
                fontFamily="FedraSansStd-book"
                listStyleType="none"
                color="#A8967F"
              >
                <ListItem paddingBottom="15px" borderBottom="1px solid #A8967F">
                  {subscripData?.sectionContent[2]?.text}
                </ListItem>
                <ListItem
                  paddingBottom="15px"
                  paddingTop="14px"
                  borderBottom="1px solid #A8967F"
                >
                  {subscripData?.sectionContent[3]?.text}
                </ListItem>
                <ListItem
                  paddingBottom="15px"
                  paddingTop="14px"
                  borderBottom="1px solid #A8967F"
                >
                  {subscripData?.sectionContent[4]?.text}
                </ListItem>
              </UnorderedList>
            </>
          )}
          <Box mt="30px" padding="0 calc((100% - 810px)/2)">
            <Text
              as="p"
              fontFamily="FedraSansStd-medium"
              textAlign="center"
              fontSize={{ base: '26px', md: '30px' }}
              color="#ffbd31"
            >
              {subscripData?.sectionContent[5]?.text}
            </Text>
            <Text
              as="p"
              fontFamily="FedraSansStd-book"
              textAlign="center"
              fontSize={{ base: '16px', md: '20px' }}
              color="#ffffff"
            >
              {subscripData?.sectionContent[6]?.text}
              {/* {PackageData[0]?.currency != 'INR'
                ? PackageData[0]?.currency
                : 'Rs.'}{' '} */}
              {PackageData[0]?.currency} {PackageData[0]?.package_amount}{' '}
              {subscripData?.sectionContent[7]?.text}
            </Text>
          </Box>
          {subscripData?.sectionContent[8]?.buttonText != '' &&
            subscripData?.sectionContent[8]?.linkUrl != '' && (
              <>
                <Box>
                  <Box
                    m="25px auto 20px auto"
                    display="block"
                    sx={{
                      button: {
                        p: { base: '14px 35px', md: 'inherit' },
                      },
                    }}
                  >
                    <BtnTryForFree
                      sectionContent={subscripData?.sectionContent[8]}
                      region={region}
                      language={language}
                      PackageData={PackageData}
                      eventname="sgx_try_free3_click"
                    />
                  </Box>

                  <Box
                    width={{ base: '100%', sm: '100%', lg: '400px' }}
                    m={{ base: '15px auto 0', md: '35px auto 0' }}
                  >
                    <Accordion allowToggle>
                      <AccordionItem
                        border="none"
                        borderRadius="12px"
                        m="0 0 20px 0"
                      >
                        {({ isExpanded }) => (
                          <>
                            <AccordionButton
                              _hover={{ bgColor: '#2F2C29' }}
                              _focus={{ bgColor: '#2F2C29', shadow: 'none' }}
                              paddingTop="10px"
                              paddingBottom="10px"
                              width={{ base: '78%', md: '65%' }}
                              margin="0 auto"
                            >
                              <Box
                                flex="1"
                                lineHeight="1.2"
                                fontFamily="FedraSansStd-A-medium"
                                fontSize={{ base: '16px', md: '20px' }}
                                color="#ffffff"
                                textDecoration="underline"
                              >
                                {subscripData?.sectionContent[9]?.text}
                              </Box>
                              <Image
                                src={`${config.imgPath}/d/46272/1676139089-down_arrow_yellow.png`}
                                title="arrow"
                                alt="arrow"
                                transform={
                                  isExpanded
                                    ? 'rotate(-180deg)'
                                    : 'rotate(0deg)'
                                }
                                w="20px"
                              ></Image>
                            </AccordionButton>

                            <AccordionPanel pb={4}>
                              <Box
                                display="flex"
                                m="0 auto"
                                w="250px"
                                height="163px"
                              >
                                <Box
                                  background={`url('${config.imgPath}/d/46272/1676139505-howitworks.png')`}
                                  backgroundRepeat="no-repeat"
                                  backgroundSize="cover"
                                  objectFit="contain"
                                  width="32px"
                                  maxHeight="153px"
                                  m="15px 0"
                                ></Box>
                                <Box
                                  textAlign="left"
                                  mt="12px"
                                  marginLeft="16px"
                                  fontSize="20px"
                                  color="#fff"
                                  fontFamily="FedraSansStd-book"
                                >
                                  <Text as="span" fontWeight="bold">
                                    {formatDate(new Date(), 'dd/mm/yyyy')}
                                  </Text>
                                  <Box className="startDate">
                                    {StructuredTextContent(
                                      subscripData?.sectionContent[10]?.body
                                    )}
                                  </Box>
                                  <Text as="p" fontWeight="bold" pt="20px">
                                    {formatDate(
                                      subDays(new Date(), -40),
                                      new Date()
                                    )}
                                  </Text>
                                  <Box className="endDate">
                                    {StructuredTextContent(
                                      subscripData?.sectionContent[11]?.body
                                    )}
                                    <h6>
                                      {subscripData?.sectionContent[12].text}{' '}
                                      {/* {PackageData[0]?.currency != 'INR'
                                        ? PackageData[0]?.currency
                                        : 'Rs.'} */}
                                      {PackageData[0]?.currency}{' '}
                                      {PackageData[0]?.package_amount}
                                      {'  '}
                                      {subscripData?.sectionContent[13].text}
                                    </h6>
                                  </Box>
                                </Box>
                              </Box>
                            </AccordionPanel>
                          </>
                        )}
                      </AccordionItem>
                    </Accordion>
                  </Box>
                </Box>
              </>
            )}
        </Box>
      </form>

      <form
        id="subscribeplan"
        method="post"
        name="subscribe"
        action={posturl}
        enctype="application/json"
      >
        <input
          type="hidden"
          name="package"
          id="package_name"
          value={PackageData[1]?.package_name}
        />
        <input
          type="hidden"
          name="country"
          id="iso2"
          value={PackageData[1]?.ios2}
        />
        <Box
          background="#2f2c29"
          marginTop="30px"
          borderRadius="12px"
          padding={{ base: '20px 25px 10px 25px', lg: '10px 50px' }}
          width={{ base: '92%', sm: '92%', lg: '882px' }}
          margin="30px auto 0"
          color="#A8967F"
        >
          <Accordion allowToggle>
            <AccordionItem
              border="none"
              _hover={{ bgColor: '#2F2C29' }}
              _focus={{ bgColor: '#2F2C29', shadow: 'none' }}
              borderRadius="12px"
              m="0 0 20px 0"
            >
              {({ isExpanded }) => (
                <>
                  <AccordionButton
                    _hover={{ bgColor: '#2F2C29' }}
                    _focus={{ bgColor: '#2F2C29', shadow: 'none' }}
                    paddingTop={{ base: '10px', md: '20px' }}
                    paddingBottom="10px"
                  >
                    <Box
                      flex="1"
                      fontFamily="FedraSansStd-A-medium"
                      fontSize={{ base: '20px', lg: '24px' }}
                      color="#ffffff"
                      lineHeight="1.2"
                    >
                      {subscripData?.sectionContent[14]?.text}
                    </Box>
                    <Image
                      src={`${config.staticPath}/assets/images/down-arrow.svg`}
                      title="arrow"
                      alt="arrow"
                      transform={
                        isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)'
                      }
                      w="33px"
                    ></Image>
                  </AccordionButton>
                  <AccordionPanel pb={4}>
                    <Box mt="30px" mb="20px" padding="0 calc((100% - 810px)/2)">
                      <Text
                        as="span"
                        fontFamily="FedraSansStd-book"
                        textAlign="center"
                        fontSize={{ base: '26px', md: '32px' }}
                        color="#ffbd31"
                      >
                        {/* {PackageData[1]?.currency != 'INR'
                          ? PackageData[1]?.currency
                          : 'Rs.'} */}
                        {PackageData[1]?.currency}
                        {'  '}
                        {PackageData[1]?.package_amount}
                      </Text>
                      <Text
                        as="span"
                        fontFamily="FedraSansStd-book"
                        textAlign="center"
                        fontSize={{ base: '28px', md: '32px' }}
                        color="#ffffff"
                      >
                        {'  '}
                        {subscripData?.sectionContent[15]?.text}
                      </Text>
                    </Box>
                    <UnorderedList
                      display="inline-block"
                      textAlign={{ base: 'left', md: 'center' }}
                      fontSize={{ base: '16px', lg: '20px' }}
                      fontFamily="FedraSansStd-book"
                      listStyleType="none"
                      color="#A8967F"
                    >
                      <ListItem
                        paddingBottom="15px"
                        borderBottom="1px solid #A8967F"
                      >
                        {subscripData?.sectionContent[16]?.text}
                      </ListItem>
                      <ListItem
                        paddingBottom="15px"
                        paddingTop="14px"
                        borderBottom="1px solid #A8967F"
                      >
                        {subscripData?.sectionContent[17]?.text}
                      </ListItem>
                    </UnorderedList>
                    {subscripData?.sectionContent[18]?.buttonText != '' &&
                      subscripData?.sectionContent[18]?.linkUrl != '' && (
                        <>
                          <Box>
                            <Box
                              m="25px auto 20px auto"
                              display="block"
                              sx={{
                                button: {
                                  p: { base: '14px 35px', md: 'inherit' },
                                },
                              }}
                            >
                              <BtnTryForFree
                                sectionContent={
                                  subscripData?.sectionContent[18]
                                }
                                region={region}
                                language={language}
                                PackageData={PackageData}
                                period="monthly"
                                eventname="sgx_monthly_plan_click"
                              />
                            </Box>
                          </Box>
                        </>
                      )}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          </Accordion>
        </Box>
        <Box m="5px 0 0 0">
          <Text
            fontSize="16px"
            fontFamily="FedraSansStd-book"
            color="#ffbd31"
            className="privacylink"
          >
            {StructuredTextContent(subscripData?.sectionContent[19]?.body)}
          </Text>
        </Box>
      </form>

      <style global jsx>{`
        .selectplan input[type='radio'] {
          width: 42px;
          height: 42px;
        }
        .selectplan input[type='radio']:after {
          width: 42px;
          height: 42px;
          top: 0px;
          left: 0px;
          position: relative;
          content: '';
          background-color: #000000;
          border-radius: 50%;
          display: inline-block;
          visibility: visible;
        }
        .selectplan input[type='radio']:checked:after {
          width: 42px;
          height: 42px;
          border-radius: 0px;
          top: 0px;
          left: 0px;
          position: relative;
          content: '';
          border-radius: 50%;
          background-image: url(/assets/images/mark.svg);
          display: inline-block;
          visibility: visible;
        }
        .startDate,
        .endDate {
          font-size: 12px;
          line-height: 18px
          text-align: left;
        }
        .startDate h5,
        .endDate h5 {
          color: #ffbd31;
        }
        .startDate h6,
        .endDate h6 {
          color: #979797;
        }
        @media screen and (max-width: 768px) {
          .selectplan input[type='radio'] {
            width: 24px;
            height: 24px;
          }
          .selectplan input[type='radio']:after {
            width: 24px;
            height: 24px;
            background-size: 24px;
          }
          .selectplan input[type='radio']:checked:after {
            width: 24px;
            height: 24px;
            background-size: 24px;
          }
        }
      `}</style>
    </>
  );
};

export default SubscriptionPlanPromo;
